module.exports = __webpack_public_path__ + "img/pending.aef7a2d2.svg";